import { LineChart } from '../../Common/Charts/LineChart';
import { useFinancingChartsDataContext } from './hooks/useFinancingChartsDataContext';

const LINE_COLORS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];

export const FinancingSourceByYear = () => {
    const { chartData } = useFinancingChartsDataContext();

    const fontePorAno = chartData?.sourceByYear || {};
    const years = Object.keys(fontePorAno).sort();

    const sourceSet = new Set();
    years.forEach((year) => {
        Object.keys(fontePorAno[year] || {}).forEach((source) => sourceSet.add(source));
    });
    const sources = Array.from(sourceSet);

    const colors = sources.map((_, index) => LINE_COLORS[index % LINE_COLORS.length]);
    const values = sources.map((source) => years.map((year) => fontePorAno[year]?.[source] ?? 0));

    return (
        <LineChart
            title={'Evolução da Fonte por Ano'}
            category={sources}
            values={values}
            subtitles={years}
            colors={colors}
        />
    );
};
